export default "__VITE_ASSET__oNMQ4xLj__"